import clsx from 'clsx';
import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  bgColor?: string;
  className?: string;
};


export const Badge: React.FC<BadgeProps> = ({
  children,
  bgColor = 'bg-gray-300',
  className
}) => {

  return (
    <span className={clsx(
      "rounded-full px-2 py-1.5",
      bgColor,
      className,
    )}>
      {children}
    </span>
  );
};